import React from 'react';
import BaseComponent from "../../../base/BaseComponent";
import {
    Input,
    Icon,
    Modal,
    Tree,
    message
} from "antd";
import {Scrollbars} from "react-custom-scrollbars";
import {uuid} from "../../../utils";

const {Search} = Input;
const {TreeNode} = Tree;

class ContributeTo extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            treeNodeVisible: false,
            treeData: [],
            // 展开的节点树
            expandedKeys: [],
            // 搜索到的key
            searchExpandedKeys: [],
            // 选中的节点
            checkedKeys: [],
            autoExpandParent: true,
            // node搜索框内容
            searchText: "",
            loadContributeToKey: uuid()
        };
    }

    componentWillMount() {

    }

    componentDidMount() {
        this.getNodes(); //获取投稿部门/媒体树
    };

    componentWillUnmount() {

    }

    openContributeModal() {
        this.setState({
            treeNodeVisible: true,
            checkedKeys: [],
            searchText: "",
            autoExpandParent: false,
            loadContributeToKey: uuid()
        })
    }

    render() {
        let {treeData} = this.state;
        let floor = 0;
        return (
            <Modal
                centered={true}
                title="投稿至"
                visible={this.state.treeNodeVisible}
                onOk={this.contributeOk}
                onCancel={() => {
                    this.setState({treeNodeVisible: false})
                }}
                width={320}
                key={this.state.loadContributeToKey}
            >
                <Search
                    placeholder="请输入关键词"
                    value={this.state.searchText}
                    onChange={(e)=>{
                        this.setState({
                            searchText: e.target.value
                        })
                    }}
                    onSearch={this.onNodeSearch}
                    style={{margin: "10px 0"}}
                />
                <Scrollbars style={{height: 300,}}>
                    {(treeData && treeData.length) ? <Tree
                        showIcon
                        checkable
                        defaultExpandParent={true}
                        defaultExpandAll={true}
                        expandedKeys={this.state.expandedKeys}
                        autoExpandParent={this.state.autoExpandParent}
                        checkedKeys={this.state.checkedKeys}
                        onExpand={this.onExpand}
                        onCheck={this.onCheck}
                        selectable={false}
                    >
                        {this.renderTreeNodes(treeData, floor)}
                    </Tree> : null}
                </Scrollbars>
            </Modal>
        );
    }

    onExpand = expandedKeys => {
        this.setState({
            expandedKeys,
            autoExpandParent: false,//这个属性要在这里面使用fasle,不然如果子节点打开，关闭父节点关闭不了，点击没反应哦，重要操作。
        });
    };

    // 投稿至树选择
    onCheck = (checkedKeys, info) => {
        console.log('checkedKeys       ', checkedKeys);
        this.setState({checkedKeys})
    };

    // 获取投稿部门/媒体树
    getNodes = () => {
        this.request({
            url: "/cm-sites-pms/contribute/nodes",
            callBack: (res) => {
                let treeData = [];
                if (res) {
                    treeData = res;
                }
                this.setState({treeData})
            },
            errorCallBack: (e) => {
                this.setState({treeData: []})
            }
        })
    };

    contributeOk = () => {
        if (!(this.state.checkedKeys && this.state.checkedKeys.length)) {
            message.destroy();
            message.warning('选择最少一个媒体或部门');
            return;
        }
        let targetIds = this.state.checkedKeys.join(',');
        let webNewsId = this.props.webNewsId;
        let body = {targetIds, webNewsId};
        this.contribute(body);
        this.setState({treeNodeVisible: false})
    };

    // 获取投稿部门/媒体树
    contribute = (body) => {
        const {refreshList} = this.props;
        this.request({
            url: "/cm-sites-pms/website/news/contribute",
            method: 'post',
            body,
            callBack: (res) => {
                message.success('投递成功');
                refreshList();
            },
            errorCallBack: (e) => {
            }
        })
    };

    onNodeSearch = (textValue) => {
        if (textValue.length < 0) {
            this.state.expandedKeys = []
        }
        this.state.searchExpandedKeys = [];
        this.getSearchOpenKey(this.state.treeData, textValue);
        this.state.autoExpandParent = true;
        this.setState({searchText: textValue, expandedKeys: this.state.searchExpandedKeys})
    };

    //获取搜索搜索字段的展开树。
    getSearchOpenKey(data, searchText) {
        if (data && data.length > 0) {
            data.forEach((item) => {
                let index = searchText.length > 0 ? item.name.indexOf(searchText) : -1;
                if (index > -1) {
                    this.state.searchExpandedKeys.push(item["id"])
                }
                this.getSearchOpenKey(item["child"], searchText)
            })
        }
    }

    renderTreeNodes = (data, floor) =>
        data.map(item => {
            if (item.child) {
                return (
                    <TreeNode title={this.renderTitle("folder-open", item, floor)} key={item.id} dataRef={item}>
                        {this.renderTreeNodes(item.child, floor + 1)}
                    </TreeNode>
                );
            }
            return <TreeNode key={item.id} title={this.renderTitle("file-text", item, floor)}/>;
        });

    renderTitle = (type, item, floor) => {
        const index = this.state.searchText.length > 0 ? item.name.indexOf(this.state.searchText) : -1;
        let width1 = 190 - floor * 19;
        let width2 = 160 - floor * 19;
        return (
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", width: width1,}}>
                <div style={{display: "flex", alignItems: "center"}}>
                    <Icon type={type}/>
                    <span style={{
                        width: width2,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                        color: index > -1 ? '#f50' : 'unset'
                    }}
                    >{item.name}</span>
                </div>
                <div onClick={(e) => {
                    e.stopPropagation();
                    this.setCollect(item)
                }}>{item.collect ? <Icon type="star" theme="filled" style={{color: "#f0a738"}}/> :
                    <Icon type="star"/>}</div>
            </div>
        )
    };

    setCollect = (item) => {
        let url = "";
        if (item.collect) { // 取消收藏
            url = "/cm-sites-pms/contribute/cancel";
        } else { // 收藏
            url = "/cm-sites-pms/contribute/collect";
        }
        this.request({
            url: url,
            body: {nodeId: item.id},
            method: "post",
            callBack: (res) => {
                this.getNodes()
            },
            errorCallBack: (e) => {
                message.error(e)
            }
        })
    };
}


export default ContributeTo;